import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "button", "icon"]

  connect() {
    // INTENT: Set initial state of mobile student filter accordion.
    // EXPECTED OUTCOME: `isShowing` tracks whether the student list is expanded on mobile views.
    // CAVEAT/TRAP: Default to false (collapsed) on mobile; CSS flex classes handle desktop visibility.
    this.isShowing = false
  }

  toggle() {
    // INTENT: Toggle student list visibility and accessibility attributes on mobile viewports.
    // EXPECTED OUTCOME: Toggles `hidden` class on list target and updates aria-expanded.
    // CAVEAT/TRAP: Ensure target checks prevent exceptions if targets are missing.
    this.isShowing = !this.isShowing

    if (this.hasListTarget) {
      this.listTarget.classList.toggle("hidden", !this.isShowing)
      this.listTarget.classList.toggle("block", this.isShowing)
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", this.isShowing.toString())
      this.buttonTarget.classList.toggle("focus:bg-blue", this.isShowing)
      this.buttonTarget.classList.toggle("hover:bg-blue", this.isShowing)
      this.buttonTarget.classList.toggle("shadow-none", this.isShowing)
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("fa-angle-up", this.isShowing)
      this.iconTarget.classList.toggle("fa-angle-down", !this.isShowing)
    }
  }
}
